var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSluice = function SvgSluice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 1.333,
    d: "M23.333 16H8.667M16 11.333v9.334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M8.75 11.417h14.5v9.167H8.75z"
  })));
};
export { SvgSluice as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cline x1='23.3333' y1='15.9999' x2='8.66667' y2='15.9999' stroke='%234A6067' stroke-width='1.33333' stroke-linecap='square'/%3e %3cline x1='16' y1='11.3334' x2='16' y2='20.6667' stroke='%234A6067' stroke-width='1.33333' stroke-linecap='square'/%3e %3crect x='8.75' y='11.4167' width='14.5' height='9.16667' stroke='%234A6067' stroke-width='1.5'/%3e %3c/svg%3e";